// Welcome banner — the design system's home hero (HomeScreen "hs-banner"):
// a deep-navy banner with the 3D mascot photo + a left-to-right scrim, a date
// label, "Hi, {name}! 👋", a message, and a frosted "start" pill. Prefix: qam-.
// The photo asset is /mascots/mascot-dashboard.webp (served from public/);
// the navy background shows through gracefully if the asset is absent.
export const welcomeStyles = `
  .qam-root {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    min-height: 190px;
    display: flex;
    align-items: center;
    border-radius: var(--rad-catchup-2xlarge);
    box-shadow: 0 22px 46px -22px rgba(15, 72, 89, 0.6);
    border: 1.5px solid rgba(255, 255, 255, 0.35);
    /* teal glass hero — matches every other page hero (.cph-root, .qdd-hero …)
       instead of the old deep-navy home banner */
    background: linear-gradient(108deg, var(--brand-light) 0%, var(--brand) 52%, var(--brand-dark) 100%);
  }
  /* corner orb — same glass cue the other heroes carry */
  .qam-root::after {
    content: "";
    position: absolute;
    right: -60px;
    top: -60px;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.22), transparent 70%);
    pointer-events: none;
  }
  .qam-photo {
    position: absolute;
    inset: 0;
    background-image: url("/mascots/mascot-dashboard.webp");
    background-size: cover;
    background-position: 64% 24%;
  }
  .qam-scrim {
    position: absolute;
    inset: 0;
    /* dark-teal scrim (same as heroBannerBackground) so the white text stays
       legible and the banner reads teal whether or not a banner photo is set */
    background: linear-gradient(
      108deg,
      rgba(15, 72, 89, 0.82) 0%,
      rgba(15, 72, 89, 0.52) 45%,
      rgba(15, 72, 89, 0.34) 100%
    );
  }
  .qam-content {
    position: relative;
    z-index: 1;
    padding: var(--space-6) var(--space-8);
    max-width: 480px;
  }
  .qam-date {
    color: rgba(255, 255, 255, 0.82);
    font-size: var(--fs-sm);
    font-weight: var(--font-weight-bold);
    letter-spacing: 0.14em;
    text-transform: uppercase;
    text-shadow: 0 1px 2px rgba(15, 72, 89, 0.22);
  }
  .qam-greeting {
    color: var(--catchup-white);
    font-size: var(--fs-great);
    font-weight: var(--font-weight-bold);
    letter-spacing: -0.01em;
    margin: 6px 0 4px;
    text-shadow: 0 1px 2px rgba(15, 72, 89, 0.28);
  }
  .qam-message {
    color: rgba(255, 255, 255, 0.9);
    font-size: var(--fs-lg);
    font-weight: var(--font-weight-medium);
    line-height: var(--leading-snug);
    text-shadow: 0 1px 2px rgba(15, 72, 89, 0.22);
  }
  .qam-cta {
    margin-top: var(--space-4);
  }
  /* Light frosted pill tuned for the dark navy banner (the shared secondary
     button's teal text is unreadable on navy). */
  .qam-cta .btn-secondary {
    width: auto;
    white-space: nowrap;
    padding-left: var(--space-6);
    padding-right: var(--space-6);
    background-color: rgba(255, 255, 255, 0.92);
    border-color: rgba(255, 255, 255, 0.85);
    color: var(--catchup-blue-700);
    box-shadow:
      inset 0 1px 1px rgba(255, 255, 255, 0.8),
      0 8px 20px -8px rgba(0, 0, 0, 0.45);
  }
  .qam-cta .btn-secondary:not(.btn-disabled):not(.btn-loading):hover {
    background-color: var(--catchup-white);
    border-color: var(--catchup-white);
    color: var(--catchup-blue-800);
    box-shadow:
      inset 0 1px 1px rgba(255, 255, 255, 0.9),
      0 10px 24px -8px rgba(0, 0, 0, 0.5);
  }
`;
